import React, { useState } from "react";
import { PRICING_LIST_TWO } from "../../mocks/Pricing";
import { PricingAreaTwoItem } from "./PricingAreaTwoItem";
import { PricingTab } from "./PricingTab";
import overviewRightBg from "../../assets/img/overview/overview_right_bg.png";

export const PricingAreaTwo = () => {
  const [isMonthly, setIsMonthly] = useState(true);

  return (
    <section className="pricing-area-two" id="pricing">
      <div
        className="pricing-shape"
        data-aos="fade-left"
        data-aos-delay="200"
        style={{ backgroundImage: `url(${overviewRightBg})` }}
      ></div>

      <div className="container">
        <div className="row align-items-center justify-content-center">
          <div className="col-lg-6">
            <div className="section-title-two mb-50 tg-heading-subheading animation-style3">
              <span className="sub-title">How Much Does Bookkeeping Cost?</span>
              <h2 className="title tg-element-title">
              Simple, Flat Monthly Pricing
              </h2>
            </div>
          </div>
          <div className="col-lg-6 col-md-10">
            <div className="section-top-content mb-30">
              <p>
              In Canada, basic bookkeeping for a small business 
              typically costs $200 to $500 a month. Silverwave's flat plans start 
              at [$250] a month, based on how many transactions you have. No hourly billing, no surprises.
              </p>
            </div>
          </div>
        </div>

        <div className="pricing-item-wrap">
          <PricingTab
            isMonthly={isMonthly}
            onToggle={() => setIsMonthly((v) => !v)}
          />

          <div className="row justify-content-center">
            {PRICING_LIST_TWO.map((item) => (
              <div key={item.id} className="col-lg-4 col-md-6 col-sm-10">
                <PricingAreaTwoItem item={item} isMonthly={isMonthly} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
